import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { LoadingButton } from '@mui/lab';
import { AMDLinkStyles } from './index';

interface PatientUpdateConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
}

const PatientUpdateConfirmModal: React.FC<PatientUpdateConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  loading
}) => {
  const linkClasses = AMDLinkStyles();

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth={true}>
      <DialogTitle
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '10px 15px 10px 30px',
          justifyContent: 'space-between'
        }}
      >
        <div
          style={{ display: 'flex', alignItems: 'center', margin: '8px 0px' }}
        >
          <InfoIcon color="error" style={{ marginRight: '8px' }} />
        </div>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography className={linkClasses.lightText}>
              Are you sure you want to update the selected AdvancedMD profile?
              The AdvancedMD data will be overwritten by the client's POW data.
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <div
        style={{
          width: '100%',
          display: 'flex',
          padding: '10px',
          justifyContent: 'flex-end'
        }}
      >
        <Button
          variant="outlined"
          style={{ marginRight: '8px' }}
          onClick={onClose}
        >
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          loading={loading}
          onClick={onConfirm}
        >
          Update AdvancedMD profile
        </LoadingButton>
      </div>
    </Dialog>
  );
};

export default PatientUpdateConfirmModal;
